export default __webpack_public_path__ + "static/media/triangle-down.1933a433.svg";